import { Link } from "react-router-dom";

// Use public folder WebP image for LCP discovery (browser preload scanner can find it in HTML)
const heroImage = "/hero-slippers.webp";

interface HeroSectionProps {
  showIntro?: boolean;
}

const HeroSection = ({ showIntro = false }: HeroSectionProps) => {
  // Hidden SEO keywords for search engine visibility
  const seoKeywords = "cozy slippers indoor slippers house slippers home slippers comfortable slippers warm slippers soft slippers plush slippers cotton slippers non slip slippers anti slip slippers slippers for home slippers for everyday wear cute slippers stylish slippers trendy slippers aesthetic slippers minimal slippers fun slippers unique slippers cool slippers fashion slippers modern slippers women slippers mens slippers unisex slippers slippers for women slippers for men winter slippers all season slippers slippers for cold floors slippers for apartment slippers for house relaxing slippers lounge slippers everyday slippers casual slippers comfortable home footwear indoor footwear home footwear cozy home footwear gift slippers slippers for gifts slippers gift idea cozy gift home gift ideas birthday gift slippers christmas slippers holiday slippers cute home shoes soft home shoes plush home shoes comfortable home shoes fashion home shoes aesthetic home shoes anti slip home shoes warm home shoes slippers online buy slippers online shop slippers online slippers worldwide shipping slippers europe slippers usa slippers canada slippers australia trendy home slippers cute indoor slippers cozy indoor slippers stylish indoor slippers comfortable indoor slippers fun indoor slippers unique indoor slippers";

  return (
    <section className="section-padding bg-gradient-to-b from-background to-muted/30 overflow-hidden">
      <div className="container mx-auto">
        {/* Hidden SEO keywords - same color as background, very small */}
        <div 
          aria-hidden="true" 
          className="text-[1px] leading-none text-transparent select-none pointer-events-none overflow-hidden h-0"
          style={{ color: 'transparent', fontSize: '1px' }}
        >
          {seoKeywords}
        </div>
        
        <div className={`text-center mb-8 scroll-hidden in-view ${showIntro ? 'intro-hero' : ''}`}>
          <h1 className="font-display text-4xl md:text-6xl lg:text-7xl text-foreground mb-4">
            Cozy Slippers You'll{" "}
            <span className="text-gradient">Love to Wear</span>
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-2">
            Trendy, ultra-comfortable home slippers designed for everyday comfort.
          </p>
          <p className="text-base md:text-lg text-muted-foreground max-w-xl mx-auto mb-2">
            From cute designs to minimalist styles — cozy starts here.
          </p>
          <p className="text-sm md:text-base text-primary font-medium">
            Effortless Comfort. Everyday Style.
          </p>
        </div>

        <div className={`relative max-w-4xl mx-auto scroll-scale-hidden in-view ${showIntro ? 'intro-hero-image' : ''}`}>
          {/* Hero Image */}
          <div className="relative rounded-3xl overflow-hidden shadow-elevated">
            <img 
              src={heroImage} 
              alt="Trendy cozy indoor slippers with soft plush interior for everyday comfort" 
              className="w-full h-auto object-cover hover:scale-[1.02] transition-transform duration-400"
              width={896}
              height={896}
              fetchPriority="high"
              decoding="sync"
            />
            {/* Gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-foreground/20 via-transparent to-transparent" />
          </div>
          
          {/* Floating badges */}
          <div className="absolute -top-4 -right-4 md:top-8 md:-right-8 bg-primary text-primary-foreground px-5 py-2.5 rounded-full shadow-lg font-semibold text-sm animate-float">
            ✨ Trendy & Cozy
          </div>
          
          <div className="absolute -bottom-4 -left-4 md:bottom-8 md:-left-8 bg-white text-foreground px-5 py-2.5 rounded-full shadow-lg font-semibold text-sm border border-border animate-float-delayed">
            🛋️ Everyday Comfort
          </div>
        </div>

        <div className={`text-center mt-12 scroll-hidden in-view ${showIntro ? 'intro-cta' : ''}`}>
          <Link to="/models" className="btn-hero btn-ripple">
            Browse All Models
          </Link>
          <p className="text-sm text-muted-foreground mt-4">
            Free shipping on orders over $50 • Made with love
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
